import type { RunStatus } from "@canvas-sync/shared";
import { runStatusLabel } from "../lib/labels";

const variants: Record<RunStatus, string> = {
  QUEUED: "badge badge-queued",
  RUNNING: "badge badge-running",
  SUCCEEDED: "badge badge-success",
  FAILED: "badge badge-failed",
  CANCELLED: "badge badge-cancelled",
};

export function StatusBadge({ status }: { status: RunStatus }) {
  return (
    <span className={variants[status]}>
      {status === "RUNNING" && <span className="badge-pulse" />}
      {runStatusLabel(status)}
    </span>
  );
}
